<template>
  <div>
      <div class="footer aem-GridColumn aem-GridColumn--default--12">
          <div class="mchp-footer">
              <div class="mchp-footer-tier1">
                  <div class="spacer"></div>
                  <div class="mchp-footer-container">
                      <div class="mchp-footer-links mchp-social-media-links">
                          <div class="mchp-component-list">
                              <div class="mchp-component-items">
                                  <div v-for="(footerItem) in footerData.socialMedia" :key="footerItem.title" class="mchp-component-item">
                                      <div class="image">
                                          <div class="cmp-image">
                                              <a :href="footerItem.link" class="cmp-image__link" :target=" footerItem.newTab ? '_blank' : '' ">
                                                  <img :src="footerItem.filePath" :alt="footerItem.alt" class="cmp-image__image">
                                              </a>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="mchp-footer-links">
                          <div class="mchp-component-list">
                              <div class="mchp-component-items">
                                  <div v-for="(footerItemText) in footerData.footerLink" :key="footerItemText.link" class="mchp-component-item">
                                      <div class="link">
                                          <div>
                                              <a :href="footerItemText.link" class="mchp-link__link" :target="footerItemText.newTab ? '_blank' : '_self'">{{footerItemText.title}}</a>
                                              <span class="mchp-link__separator">{{footerItemText.separator}}</span>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div v-if="footerData.signUpText" class="mchp-footer-newsletter">
                          <div class="mchp-signup-btn">
                              <div id="text-d8e2c38fb6" v-html="footerData.signUpText.text" class="cmp-text"></div>
                          </div>
                          <div class="mchp-signup-btn">
                              <div class="mchp-button-wrapper">
                                  <a role="button" :href="footerData.signUpButton.link" :class="footerData.signUpButton.buttonStyle" class="mchp-button mchp-button-regular">
                                      <span class="mchp-button__span">{{footerData.signUpButton.text}}</span>
                                  </a>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div v-if="footerData.graphicData" class="graphic">
                      <div>
                          <div id="image-026e34166a" class="cmp-image">
                              <img class="cmp-image__image" :alt="footerData.graphicData.alt" :src="footerData.graphicData.filePath">
                          </div>
                      </div>
                  </div>
              </div>
              <div class="mchp-footer-tier2">
                  <p class="mchp-copyright">
                      © Copyright 1998-<span id="currentYear">{{getCurrentYear}}</span> Microchip Technology Inc. All rights reserved.
                  </p>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import FooterData from "../../api/dataservice";
import DefaultFooterData from "../../FallBackFiles/DefaultFooter.json";
export default {
  name: "FooterComponent",
  data() {
      return {
          footerData: {},
          getCurrentYear: '',
          environment: process.env.NODE_ENV,
      }
  },
  mounted() {
      this.getCurrentYear = new Date().getFullYear();
      if (this.environment === 'production') {
      FooterData.getFooterData('123')
              .then((data) => {
                  this.renderFooterData(data);
              })
              .catch(function() {
              });
      } else {
          this.renderFooterData(DefaultFooterData);
      }
  },
  methods: {
      renderFooterData(data) {
          this.footerData = data;
      },
  }
}
</script>